<template>
  <!-- <div > -->
  <section class="app-main" :class="contentClass">
    <!--<transition-->
    <!--name="fade"-->
    <!--mode="out-in"-->
    <!--&gt;-->
    <!-- <router-view :key="key"></router-view> -->
    <!-- <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" v-if="$route.meta.keepAlive" />
      </keep-alive>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </transition> -->
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" v-if="$route.meta.keepAlive" />
      </keep-alive>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <!--</transition>-->
  </section>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      tabData1: [],
    };
  },
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name : this.$route + new Date();
    // },
    key() {
      return this.$route.path;
    },
    contentClass() {
      const { contentClass } = this.$store.state;
      return `${contentClass || 'bg-white'}`;
    },
  },
};
</script>
<style scoped>
.app-main {
  min-height: 100%;
}
.topmenu {
  padding-top: 5px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
}
</style>
